import type { CalendarListBlockProps } from "./types";

import { Card, Heading, Link, Paragraph } from "@digdir/designsystemet-react";

export type { CalendarListBlockProps };

export const CalendarListBlock = ({ events }: CalendarListBlockProps) => {
  if (!events || events.length === 0) return null;

  return (
    <div className="flex flex-col gap-5">
      {events.map((event, i) => (
        <Card
          key={`${event.title}-${event.start}-${i}`}
          className="flex flex-col gap-[7px] p-5.5 rounded-none border border-neutralNsf-subtle md:gap-2 md:p-6 xl:gap-[9px] xl:p-[27px]"
        >
          {event.organizer && (
            <Paragraph className="!mb-0 text-sm text-neutralNsf-subtle">
              {event.organizer}
            </Paragraph>
          )}

          <Heading level={2} className="heading-sm mb-0 text-main">
            <Link href={event.url}>{event.title}</Link>
          </Heading>
          <Paragraph className="!mb-0 text-sm text-neutralNsf-subtle">
            {event.start} - {event.end}
          </Paragraph>
        </Card>
      ))}
    </div>
  );
};
